import "./widgets-core3.css";
import { defineComponent as p, useCssVars as f, unref as m, computed as h, openBlock as t, createElementBlock as o, createElementVNode as _, Fragment as w, renderList as v, renderSlot as C, toDisplayString as k, createCommentVNode as T } from "vue";
import { u as b } from "./chunks/useTheme.L4REnSCw.js";
import { _ as x } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const I = { class: "list" }, M = /* @__PURE__ */ p({
  __name: "TruncateList",
  props: {
    data: {},
    showMoreText: {},
    showItems: { default: 3 }
  },
  emits: ["showMore"],
  setup(l, { emit: i }) {
    f((s) => ({
      "56a7ef83": m(r).actionColor.base,
      "56ae2586": m(r).actionColor.over
    }));
    const e = l, c = i, u = h(
      () => e.data.slice(0, e.showItems)
    ), r = b();
    return (s, n) => (t(), o("div", null, [
      _("ul", I, [
        (t(!0), o(w, null, v(u.value, (a, d) => (t(), o("li", { key: d }, [
          C(s.$slots, "default", { item: a }, void 0, !0)
        ]))), 128))
      ]),
      e.data.length > e.showItems ? (t(), o("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => c("showMore")),
        class: "show-more"
      }, k(s.showMoreText), 1)) : T("", !0)
    ]));
  }
}), B = /* @__PURE__ */ x(M, [["__scopeId", "data-v-e1b37be3"]]);
export {
  B as default
};
//# sourceMappingURL=widgets-core.es4.js.map
